import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AuthService } from '../../../auth/services/auth/auth.service';
import type { IOnboardingStatusResponse } from '../../../auth/interfaces';
import { ApiConfigService } from '../../../shared/services/api-config/api-config.service';
import type { IOnboardingResponse } from '../models/onboarding-common.interface';
import type { IOnboardingSaveStepRequest } from '../models/onboarding-save-step-request.interface';

@Injectable({
  providedIn: 'root',
})
export class OnboardingApiService {
  private readonly httpClient = inject(HttpClient);
  private readonly authService = inject(AuthService);
  private readonly apiConfigService = inject(ApiConfigService);

  public getStatus(): Observable<IOnboardingStatusResponse> {
    return this.authService.getOnboardingStatus();
  }

  public saveStep(request: IOnboardingSaveStepRequest): Observable<IOnboardingStatusResponse> {
    return this.authService.updateOnboardingStatus(
      request.step_number,
      request.step_data,
      request.step_id,
    );
  }

  public complete(onboardingData: Record<string, unknown> = {}): Observable<IOnboardingResponse> {
    return this.httpClient.post<IOnboardingResponse>(this.apiConfigService.onboarding.completeUrl(), {
      onboarding_data: onboardingData,
    });
  }

  public finish(): Observable<IOnboardingResponse> {
    return this.httpClient.post<IOnboardingResponse>(this.apiConfigService.onboarding.finishUrl(), {});
  }
}
